import {TaskbarEntry} from "./Widgets/TaskbarMenuEntry";
import {userConfiguration} from "../../config";
import {CreateElement} from "../Utilities/CreateElement";
import {DraggableWindow} from "./DraggableWindow";
import {taskManager} from "../globals";

export class AppMenu extends TaskbarEntry {
    isVisible: boolean = false;

    constructor() {
        super(CreateElement(`<button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#appGridModal"><i class="bi bi-grid"></i></button>`));

        const modal = CreateElement(`
<div class="modal" id="appGridModal" tabindex="-1" aria-labelledby="appGridModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content bg-transparent border-0">
            <div class="row row-cols-2 row-cols-md-5 g-2 g-sm-1" id="appGrid">
            </div>
        </div>
    </div>
</div>
`);
        document.body.appendChild(modal);
        const appGridContainer = document.getElementById('appGrid');
        if (appGridContainer != null) {
            userConfiguration.ApplicationProvider().map(app => {
                const appButton = CreateElement(`
<button class="card d-block mx-auto bg-transparent border-0" style="width: 10rem;" data-bs-dismiss="modal">
    <img src="${app.icon}" alt="${app.title}" style="width: 5rem;" class="card-img-top d-block mx-auto">
    <div class="card-body">
        <div class="card-title text-light text-wrap">${app.title}</div>
    </div>
</button>`);
                appButton.addEventListener('click', () => {
                    const draggableWindow = new DraggableWindow(app);
                    const task = taskManager.addTask(draggableWindow);
                    draggableWindow.onclose = (force): boolean => {
                        taskManager.removeTask(task.id);
                        return false;
                    }
                });
                const gridEntry = CreateElement(`<div class="col"></div>`);
                gridEntry.appendChild(appButton);
                appGridContainer.appendChild(gridEntry);
            });
            // userConfiguration.ApplicationProvider().map(app => {
            //     this.addMenuItem(CreateElement(`<div><img src="${app.icon}" style="height: 32px; width: auto; padding-right: 8px;" alt="${app.title}"/><span style="cursor: pointer;">${app.title}</span></div>`), () => {
            //         const draggableWindow = new DraggableWindow(app);
            //         const task = taskManager.addTask(draggableWindow);
            //         draggableWindow.onclose = (force): boolean => {
            //             taskManager.removeTask(task.id);
            //             return false;
            //         }
            //     });
            // });
        }
    }
}